module.exports = __webpack_public_path__ + "static/media/eye-solid.487cc758.svg";